import { Trans } from '@lingui/macro';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import React, { FC, useContext, useState, useEffect } from 'react';
import { Button, Form, Toast } from 'react-bootstrap';
import ReactQuill from 'react-quill';
import { Context } from '../..';
import AskService from '../../services/AskService';
import { AskSpecializationModal } from './modal/AskSpecializationModal';
import { formats, modules } from './modal/QuillSettings';


const Ask: FC = () => {
    const { store } = useContext(Context);
    const [data, setData] = useState<any>({});
    const [message, setMessage] = useState('');
    const [showToast, setShowToast] = useState(false);
    const [toastInfo, setToastInfo] = useState('');
    const userInfo = store.user.is_staff ? toJS(store.specInfo) : toJS(store.userInfo);
    const email = store.user.email;

    useEffect(() => {
        setData({ ...data, 'question': message })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [message]);

    useEffect(() => {
        setData({ ...data, 'user': userInfo, 'email': email })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onChange = (e: any) => {
        setData({ ...data, [e.target.name]: e.target.value })
    };

    const getQA = async () => {
        const qa = await AskService.getQ();
        store.setQA(qa.data.results);
    };

    const createQA: any = async () => {
        try {
            await AskService.createQ(data);
            setToastInfo(store.lang === 'ba' ? 'Һорау ебәрелде' : store.lang === 'ru' ? 'Вопрос был отправлен' : 'The question has been sent');
            setShowToast(true);
            getQA();
        } catch (e) {
            setToastInfo(store.lang === 'ba' ? 'Һорау ебәрелмәне' : store.lang === 'ru' ? 'Вопрос не был отправлен' : 'The question was not sent');
            setShowToast(true);
            console.log(e);
        }
    };

    return (
        <div>
            {store.user.is_active ?
                <Form className='row m-5'>

                    <Form.Group className="mb-3" controlId="formEmail">
                        <Form.Label><Trans>Your email</Trans>: <strong>{store.user?.email}</strong></Form.Label>
                    </Form.Group>

                    <Form.Group className="col-md-6 mb-3" controlId="formSubject">
                        <Form.Label><Trans>Subject</Trans></Form.Label>
                        <Form.Control
                            type="text"
                            placeholder={store.lang === 'ba' ? 'Теманы индерегеҙ' : store.lang === 'ru' ? 'Введите тему' : 'Enter subject'}
                            name='subject'
                            onChange={(e: React.ChangeEvent<any>) => onChange(e)} />
                    </Form.Group>

                    <Form.Group className="col-md-6 mb-3">
                        <Form.Label><Trans>Choose a specialist</Trans></Form.Label>
                        <AskSpecializationModal data={data} setData={setData} />
                        <Form.Text className="text-muted">
                            <Trans>Select the specialist you want to ask a question</Trans>
                        </Form.Text>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formMessage">
                        <Form.Label><Trans>Message</Trans></Form.Label>
                        <ReactQuill
                            theme="snow"
                            modules={modules}
                            formats={formats}
                            onChange={setMessage} />
                        {/* <Form.Control as="textarea" rows={5}
                            placeholder={store.lang === 'ba' ? 'Хәбәр индерегеҙ' : store.lang === 'ru' ? 'Введите сообщение' : 'Enter message'}
                            name='message'
                            onChange={(e: React.ChangeEvent<any>) => onChange(e)} /> */}
                    </Form.Group>

                    <Form.Group className="col-md-6 mb-3">
                        <Button variant="primary" type="button" onClick={() => createQA()}>
                            <Trans>Send</Trans>
                        </Button>
                    </Form.Group>

                    <Toast className='toast p-0 border-success' bg='light' onClose={() => setShowToast(false)} show={showToast} delay={5000} autohide>
                        <Toast.Header className='bg-success m-0 text-light'>
                            <strong className="me-auto"><Trans>Information</Trans></strong>
                        </Toast.Header>
                        <Toast.Body><strong>{toastInfo}</strong></Toast.Body>
                    </Toast>

                </Form>
                : <div className='m-5 text-center'><Trans>For ask a question to specialists, please log in</Trans></div>}
        </div>
    )
};
export default observer(Ask);